
import { useQuery } from '@tanstack/react-query';
import { ecommercePriceService } from '@/services/ecommercePriceService';
import { EcommercePriceFilters } from '@/types/database/ecommerce-prices';

export const useEcommercePrices = (filters: EcommercePriceFilters = {}) => {
  return useQuery({
    queryKey: ['ecommerce-prices', filters],
    queryFn: () => ecommercePriceService.getAll(filters),
  });
};

export const useEcommerceUniqueProducts = () => {
  return useQuery({
    queryKey: ['ecommerce-unique-products'],
    queryFn: () => ecommercePriceService.getUniqueProducts(),
  });
};
